import { useCallback, useEffect, useState } from "react";
import {
  dismiss,
  getState,
  startPolling,
  subscribe,
} from "../services/incidentState";

// Polling is never stopped on unmount: the store is a singleton shared by the
// root-mounted banner and by Standard.jsx, and the root banner lives for the
// whole session.
const useIncidentBanner = () => {
  const [state, setState] = useState(getState);

  useEffect(() => {
    const unsubscribe = subscribe(setState);
    startPolling();
    return unsubscribe;
  }, []);

  const close = useCallback(() => dismiss(), []);

  return { visible: state.active && !state.dismissed, active: state.active, close };
};

export default useIncidentBanner;
